import { isAxiosError } from "axios";

/** The `code` a 403 carries when the platform blocked the account or member (US-111, PD-0054). */
export const ACCOUNT_BLOCKED_CODE = "account_blocked";

/** The sign-in pages read this from `?error=` and print the blocked line. */
export const ACCOUNT_BLOCKED_QUERY = `error=${ACCOUNT_BLOCKED_CODE}`;

/** Whether an HTTP error is the platform's block — a 403 with `code: "account_blocked"`. */
export const isAccountBlockedError = (error: unknown): boolean => {
  if (!isAxiosError(error) || error.response?.status !== 403) return false;
  const data: unknown = error.response.data;
  return typeof data === "object" && data !== null && (data as { code?: unknown }).code === ACCOUNT_BLOCKED_CODE;
};
